import React from 'react';
import { IValueAgentRow } from './interface';
import { ValueRow } from '../ValueRow';
import { AgentBadge } from '../../AgentBadge';

export const ValueAgentRow: React.FC<IValueAgentRow> = ({
  label,
  agent,
  width,
}): JSX.Element => {
  return (
    <ValueRow label={label} width={width}>
      <AgentBadge agent={agent} />
    </ValueRow>
  );
};
